/**
 * Author: postcodex
 * Date: 10/6/20
 * Time: 5:33 PM
 */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ErrorBoundary from '../../../components/ErrorBoundary';
import style from '../style.scss';

class SuggestionItem extends Component {
	constructor( props ) {
		super( props );
	}

	onClick = ( e ) => {
		e.preventDefault();
		const { address } = this.props;

		this.props.onClick( address, e );
	};

	render() {
		const { address } = this.props;

		return (
			<ErrorBoundary>
				<div className={ `result-item ${ style.resultItem }` } key={ address.hash } onClick={ this.onClick }>
					{ address.addressDescription }
				</div>
			</ErrorBoundary>
		);
	}
}

SuggestionItem.propTypes = {
	address : PropTypes.object.isRequired,
	onClick : PropTypes.func.isRequired,
};

SuggestionItem.defaultProps = {
	onClick : ( address, e ) => {alert( 'onCLick() handler for SuggestionItem component is not implemented!' );}
};

export default SuggestionItem;
